import type { PdfInitResponse, PdfStatusResponse, PdfRemoveResponse, PdfDownloadResponse } from '@mrb91002/shared-types'

import { secureFetch, SECURE_API_BASE } from './helpers'

/**
 * Initialize a PDF upload session.
 * Returns a presigned S3 URL for direct browser upload.
 */
export async function initPdfUpload(
  patternId: string,
  filename: string,
  fileSize: number,
  idToken: string,
): Promise<PdfInitResponse> {
  return secureFetch<PdfInitResponse>(
    `${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/pdf/init`,
    idToken,
    {
      method: 'POST',
      body: JSON.stringify({ filename, file_size: fileSize }),
    },
  )
}

/**
 * Poll the status of a PDF upload/scan session.
 */
export async function getPdfStatus(
  patternId: string,
  uploadId: string,
  idToken: string,
): Promise<PdfStatusResponse> {
  return secureFetch<PdfStatusResponse>(
    `${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/pdf/status?upload_id=${encodeURIComponent(uploadId)}`,
    idToken,
    { method: 'GET' },
  )
}

/**
 * Remove a PDF attachment from a pattern.
 */
export async function removePdf(
  patternId: string,
  hash: string,
  idToken: string,
): Promise<PdfRemoveResponse> {
  return secureFetch<PdfRemoveResponse>(
    `${SECURE_API_BASE}/pattern/${encodeURIComponent(patternId)}/pdf/${encodeURIComponent(hash)}`,
    idToken,
    { method: 'DELETE' },
  )
}

/**
 * Get a signed download URL for a published pattern's PDF.
 */
export async function downloadPdf(
  patternId: string,
  hash: string,
  idToken: string,
): Promise<PdfDownloadResponse> {
  return secureFetch<PdfDownloadResponse>(
    `${SECURE_API_BASE}/patterns/${encodeURIComponent(patternId)}/pdfs/${encodeURIComponent(hash)}/download`,
    idToken,
    { method: 'GET' },
  )
}
